export enum ProductInfo {
  CompanyName = 'Customis3d Ltd',
  Email = 'contact@customis3d.app',
}
